<template>
  <div>
    <div class="container top-level-div">
      <!-- <div class="row" style="margin-bottom: 30px;">
        <div class="col-lg-3 col-md-3 dashboard-button" :class="{ 'dashboard-button-active': tab == 'opportunities' }" @click="tab = 'opportunities'">
          Opportunities
        </div>
        <div class="col-lg-3 col-md-3 dashboard-button" :class="{ 'dashboard-button-active': tab == 'events' }" @click="tab = 'events'">
          Events
        </div>
        <div class="col-lg-3 col-md-3 dashboard-button" :class="{ 'dashboard-button-active': tab == 'profile' }" @click="tab = 'profile'">
          Profile
        </div>
        <div class="col-lg-3 col-md-3 dashboard-button" :class="{ 'dashboard-button-active': tab == 'logout' }" @click="logout()">
          Logout
        </div>
      </div> -->

      <!-- <transition name="slide" mode="out-in">
        <div v-if="(tab == 'profile') && user.id" key="profile">
          <app-profile :userID="user.id"></app-profile>
        </div>
        <div v-if="(tab == 'opportunities') && user.id" key="opportunities">
          <app-jobs :userID="user.id"></app-jobs>
        </div>
        <div v-if="(tab == 'events') && user.id" key="events">
          <app-my-events :userID="user.id"></app-my-events>
        </div>
      </transition> -->

      <div v-if="user.id" key="profile">
        <app-profile :userID="user.id"></app-profile>
      </div>

    </div>
  </div>

</template>

<script>
  import axios from 'axios';

  import Profile from './profile/Profile';
  import Jobs from './jobs/Jobs';
  import MyEvents from '../events/MyEvents';

  export default {
    props: ['employerID'],
    data() {
      return {
        tab: 'opportunities',

        // editing: false,
        user: {},
        employerName: ''
      }
    },
    components: {
      appProfile: Profile,
      appJobs: Jobs,
      appMyEvents: MyEvents,
    },
    created() {
      this.getUser()

      // Scroll the window back up after saving the step
      window.scrollTo(0,0); // https://stackoverflow.com/questions/50449123/vue-js-scroll-to-top-of-page-for-same-route
    },
    methods: {
      getUser() {
        var userID = null
        if (this.employerID) {
          userID = this.employerID
        } else {
          userID = this.$store.getters.userID
        }
        // console.log(this.$store.getters.userID)
        // axios.get('/api/people/?id='.concat(this.$store.getters.userID))
        axios.get('/api/people/?id='+userID.toString())
          .then(res => {
            // console.log(res)
            this.user = res.data[0]

            this.employerName = this.user.employer_name
            // this.firstName = this.user.first_name
            // this.lastName = this.user.last_name
            // this.phone = this.user.phone
            // this.city = this.user.city
            // this.provinceState = this.user.provincestate
            // this.country = this.user.country
            // this.postalCode = this.user.postal_code
            // this.address1 = this.user.address1
            // this.address2 = this.user.address2

            // The idea here is the first time someone logs in, or if they haven't yet filled in step 1, they should immediately be in edit mode
            if (!this.employerName) {
              // this.editing = true
              this.tab = 'profile'
            }
          })
          .catch(error => console.log(error))
      },
      logout() {
        this.$store.dispatch('logout')
      },
    },
  }
</script>

<style>
  .dashboard-button {
    background-color: var(--thrivehiregrey);
    /* background-color: var(--bootstrapgrey); */
    /* background-color: var(--coredarkcolor); */
    color: var(--corelightcolor);
    /* margin-right: 2px; */
    border-right: 2px solid white;
    padding-top: 6px;
    padding-bottom: 6px;
    cursor: pointer;
    font-family: 'articulatcf-demibold', 'Open Sans', 'Lato';
  }
  .dashboard-button-active {
    background-color: var(--thrivehiregrey);
    background-color: var(--coredarkcolor);
    color: var(--corelightcolor);
    /* margin-right: 2px; */
    /* padding-top: 6px; */
    /* padding-bottom: 6px; */
  }

  /* Lecture 299 */
  .slide-enter-active {
    animation: slide-in 300ms ease-out forwards;
  }

  .slide-leave-active {
    animation: slide-out 300ms ease-out forwards;
  }

  @keyframes slide-in {
    from {
      transform: translateY(-30px);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }

  @keyframes slide-out {
    from {
      transform: translateY(0px);
      opacity: 1;
    }
    to {
      transform: translateY(-30px);
      opacity: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/employers/Dashboard.vue